
















































import { Component, Vue, Watch } from 'vue-property-decorator';
import PageHeader from '@/components/common/PageHeader.vue';
import EmptyItem from '@/components/common/EmptyItem.vue';
import v8n from 'v8n';
import { Program, User } from '@/api/';
import snackModule from '@/store/Snack';

@Component({ components: { PageHeader, EmptyItem } })
export default class AdminProgramsSingle extends Vue {
  /* Attributes */
  title: string;

  item: Program | null = null;

  users: User[] = [];

  notFound = false;

  loading = false;

  valid = false;

  /* Form validations */
  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || this.$t('common.validation.generalRequired'),
  ];

  optionalString = [
    (v: string) =>
      v8n()
        .optional(v8n().string(), true)
        .test(v),
  ];

  /* Getter & setter */
  get itemId() {
    return this.$route.params.itemId;
  }

  get isNewItem() {
    return this.itemId === undefined;
  }

  /* Functions */
  async save() {
    if (!this.item) return;
    try {
      this.loading = true;
      await this.item.save({ with: ['users.id'] });
      this.$emit('updated', this.item);
      snackModule.setSuccess(this.$t('common.alerts.success') as string);
    } catch (e) {
      snackModule.setError({
        text: this.$t('Programs.alerts.notSaved') as string,
        errors: (e as ErrorResponse).response.errors,
      });
    } finally {
      this.loading = false;
    }
  }

  async getUsers() {
    try {
      this.users = (await User.select(['id', 'email']).all()).data || [];
    } catch (e) {
      snackModule.setError({
        text: this.$t('programs.alerts.couldNotGetUsers') as string,
        errors: (e as ErrorResponse).response.errors,
      });
    }
  }

  @Watch('itemId', { immediate: true })
  async itemIdChanged() {
    if (this.isNewItem) {
      this.title = 'New Program';
      this.item = new Program();
    } else {
      this.title = 'Edit Program';
      try {
        this.item = (await Program.find(this.itemId)).data || null;
      } catch (e) {
        this.notFound = true;
      }
    }
  }

  mounted() {
    this.getUsers();
  }
}
